/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-param-reassign */
import * as Cesium from "cesium";
import { ColorSettings } from "./colorAdjustments";

type StyleType = "color" | "pointSize" | "defines" | "show";

type ValueType =
  | string
  | number
  | undefined
  | { [key: string]: string }
  | boolean
  | ColorSettings;

type TypeArg = { type: StyleType; newValue: ValueType };

type UpdateTilesetStyleArgs = { tileset: Cesium.Cesium3DTileset } & TypeArg;

// Uses a record to force every StyleType to exist in the list, value does not matter
const TilesetStyleTypes: Record<StyleType, boolean> = {
  color: true,
  defines: true,
  pointSize: true,
  show: true,
};

// Helper function to update a single key in the style
// Keeps the other values same as before
async function updateStyle(
  tileset: Cesium.Cesium3DTileset,
  type: StyleType,
  val: ValueType,
): Promise<Cesium.Cesium3DTileStyle> {
  await tileset.style?.readyPromise;
  const typeKeys = Object.keys(TilesetStyleTypes) as StyleType[];
  const otherTypes = typeKeys.filter((t) => t !== type);
  const otherValues: { [key in StyleType]?: unknown } = {};
  otherTypes.forEach((o) => {
    const prevVal = tileset.style?.style?.[o];
    if (prevVal ?? false) {
      otherValues[o] = prevVal;
    }
  });
  return new Cesium.Cesium3DTileStyle({
    ...(val ? { [type]: val } : {}),
    ...otherValues,
  });
}

export const updateTilesetStyle = async ({
  tileset,
  type,
  newValue,
}: UpdateTilesetStyleArgs): Promise<void> => {
  if (!tileset.style) return;
  const newStyle = await updateStyle(tileset, type, newValue);
  if (!newStyle) return;
  if (tileset.style.ready) {
    tileset.style = newStyle;
  } else {
    tileset.style.readyPromise.then((ts) => {
      if (!newStyle || !ts) return;
      ts = newStyle;
    });
  }
};
